import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  Popover,
  Text,
  Textarea,
  TextInput,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import Repository from "../../../_base/helper/HttpHelper";
import { hasLength, useForm } from "@mantine/form";
import { CategorySEO } from "./SEOModal";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useState } from "react";

interface EditProps {
  item: any;
  onClose: (refresh: boolean) => void;
}

export const EditViewSeo = ({ item, onClose }: EditProps) => {
  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
  const [visible, { open, close }] = useDisclosure(false);
  const [popoverOpened, setPopoverOpened] = useState(false);
  const form = useForm({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: item,
    validate: {
      name: hasLength({ min: 3 }, "Tên danh mục phải dài hơn 3 ký tự"),
      requestPath: (value) => (!value ? "Vui lòng nhập đường dẫn" : null),
    },
  });

  const handleEdit = async (values: typeof form.values) => {
    open();
    try {
      const updateData = {
        id: item.id,
        ...values,
      };

      const res = await repository.post<any>(
        `/TblCategoryForSeo/edit`,
        updateData
      );
      if (res && res.success) {
        NotificationExtension.Success("Cập nhật thành công!");
        onClose(true);
        modals.closeAll();
      } else {
        NotificationExtension.Fails("Cập nhật thất bại!");
      }
    } catch (error) {
      console.error("Edit error:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi cập nhật!");
    } finally {
      close();
    }
  };

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={600}
        mx="auto"
        onSubmit={form.onSubmit((e: Partial<CategorySEO>) => {
          handleEdit(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Group grow wrap="nowrap" mt="md" gap="xl">
          <TextInput
            label="Tên danh mục"
            placeholder="Nhập tên danh mục"
            withAsterisk
            {...form.getInputProps("name")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="md" gap="xl">
          <TextInput
            label="Đường dẫn (Link sản phẩm)"
            placeholder="Nhập đường dẫn (VD: /category-name)"
            withAsterisk
            {...form.getInputProps("requestPath")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="md" gap="xl">
          <TextInput
            label="Khoảng lọc giá"
            placeholder="Nhập khoảng lọc giá (VD: 1000; 5000)"
            {...form.getInputProps("summary")}
          />
          {/* <Select
                    label="Trạng thái"
                    placeholder="Chọn trạng thái"
                    data={[
                        { value: "true", label: "Hiển thị" },
                        { value: "false", label: "Ẩn" },
                    ]}
                    {...form.getInputProps("status")}
                /> */}
        </Group>

        <Group grow wrap="nowrap" mt="md" gap="xl">
          <TextInput
            label="Meta Title"
            placeholder="Nhập meta title"
            {...form.getInputProps("metaTitle")}
          />
          <TextInput
            label="Meta Keywords"
            placeholder="Nhập meta keywords"
            {...form.getInputProps("metaKeyword")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="md" gap="xl">
          <Textarea
            label="Meta Description"
            placeholder="Nhập meta description"
            rows={6}
            {...form.getInputProps("metaDescription")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="md" gap="xl">
          <Checkbox label="Hiển thị mục lục đầu bài viết" />
        </Group>

        <Group justify="flex-end" mt="lg">
          <Button
            type="submit"
            color="blue"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <Popover
            width={300}
            position="top"
            withArrow
            shadow="md"
            opened={popoverOpened}
            onChange={setPopoverOpened}
          >
            <Popover.Target>
              <Button
                color="red"
                style={{ marginLeft: 10 }}
                onClick={() => setPopoverOpened(true)}
                leftSection={<IconX size={18} />}
              >
                Đóng
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <Text>Bạn có chắc chắn muốn đóng không?</Text>
              <Group grow mt="lg">
                <Button
                  color="red"
                  leftSection={<IconCheck size={18} />}
                  onClick={() => {
                    modals.closeAll();
                  }}
                >
                  Đóng
                </Button>
                <Button
                  variant="outline"
                  color="gray"
                  leftSection={<IconX size={18} />}
                  onClick={() => setPopoverOpened(false)}
                >
                  Hủy
                </Button>
              </Group>
            </Popover.Dropdown>
          </Popover>
        </Group>
      </Box>
    </>
  );
};
